/**
 * HotelImages component.
 * Manages functionality of the hotel details content (similar to accordion)
 *
 * @param $
 * @param Object
 * @param OptionsMixin
 * @param EventDispatcher
 * @param Map
 * @param VisibilityControl
 * @param LazyImage
 * @returns {HotelDetails}
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'clientComponents/map/baseMap',
    'library/fcse-visibilitycontrol/visibilityControl',
    'clientComponents/lazyimage/lazyImage',
    'clientComponents/zooverreviews/zooverReviews',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-content/tabs',
    'library/fcse-dropdown/dropdown',
    'library/fcse-util/url',
    'clientComponents/traveltainmentratings/travelTainmentRatings'
],
    function(
        $,
        Object,
        OptionsMixin,
        EventDispatcher,
        Map,
        VisibilityControl,
        LazyImage,
        ZooverReviews,
        MultiRequestHandler,
        Tabs,
        Dropdown,
        Url,
        TravelTainmentRatings
    ) {

        var HotelDetails = function(options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {
                traveltainment_route: 'allt_frontend.traveltainment.rating_content',
                mapSelector: '[data-fcse-role="googlemap--mapcontent"]',
                destinationInfoMapSelector: '[data-fcse-role="googlemap--destination-info-mapcontent"]',
                zooverSelector: '#testimotiallist',
                zooverRoute: 'allt_frontend.zoover',
                accordionReviewsSelector: '[data-fcse-role="hotel-reviews"]',
                traveltainmentContainerSelector: '[data-fcse-role="traveltainment-container"]',
                reviewsFallbackSelector: '#reviews-fallback-text',
                accordionRatingContentSelector: '[data-fcse-role="accordion-rating-content"]',
                loadingClass: 'is-loading',
                ratingTabContainerSelector: '[data-fcse-role="hotel-ratings-tab"]'
            };
            this._hasReviews = null;
            this.element = null;
            this.zooverReviews = null;
            this.travelTainmentRatings = null;

            this.addOptions(defaultOptions, options);

            this._init();
        };

        HotelDetails.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),
            {
                /**
                 * Init the component
                 * @private
                 */
                _init: function()
                {
                    var zooverReviews = $(this.option('zooverSelector'), this.element);
                    this.element = this.option('element') || $(this.option('elementSelector'));

                    if (this.element.length != 1) {
                        throw new Error('Only one element of type ' + this.option('elementSelector') +
                            ' is expected, ' + this.element.length + ' resolved.');
                    }
                    let requestHandler = new MultiRequestHandler();
                    this._requestHandler = requestHandler;
                    this.mapElement = $(this.option('mapSelector'), this.element);
                    this.destinationinfoMapElement = $(this.option('destinationInfoMapSelector'), this.element);

                    if (zooverReviews.length) {
                        this.zooverReviews = new ZooverReviews(zooverReviews, this.option('zooverRoute'));
                    }

                    if ($('body').data('is-mobile')) {
                        this.mobileSwitcher = new Dropdown('#widget-hotel-detail-selector');

                        // Initialize Rating-Filter-Dropdown
                        this.ratingFilter = new Dropdown($('[data-widget-type="widget-rating-filter"]', this.element));
                        this.ratingFilter.on('change', $.proxy(this._onRatingFilterChange, this));
                    } else {
                        this.tabs = new Tabs(
                          '.hotel-details--tabcontainer > ul.tabnavigation',
                          '.hotel-details--tabcontainer > .tabcontainer',
                          {}
                        );
                    }

                    var urlObj = new Url();
                    if (urlObj.query.sto === '1') {
                        $(window).scrollTop($('#offerlist').offset().top);
                    }

                    this._bindEventHandlers();

                    this.ttContainer = $(this.option('traveltainmentContainerSelector'));
                    this.ttContainer.on('click', '[data-toggle-tab]', $.proxy(function (e) {
                        const el = $(e.currentTarget);
                        this.ttContainer
                            .find('[data-tab-name]')
                            .addClass('is-hidden');
                        this.ttContainer
                            .find('[data-tab-name="' + el.data('toggle-tab') + '"]')
                            .removeClass('is-hidden');
                        this.ttContainer
                            .find('[data-toggle-tab] a')
                            .removeClass('is-active');
                        el.find('a').addClass('is-active');

                        return false;
                    }, this));

                    const ratingTabs = [];
                    $(this.option('ratingTabContainerSelector')).each(function (i, el) {
                        ratingTabs.push(new TravelTainmentRatings(el, requestHandler));
                    });
                },

                /**
                 * Init a map instance
                 * @private
                 */
                _initMap: function(mapElementKind)
                {
                    var element,
                        timeout = 50,
                        interval;
                    if (mapElementKind == 'mapElement') {
                        element = this.mapElement;
                        this._initMapDone = true;
                    } else if (mapElementKind == 'destinationInfoMap') {
                        element = this.destinationinfoMapElement;
                        this._initDestinationInfoMapDone = true;
                    }
                    // waiting while element is not visible
                    if (element.length > 0) {
                        interval = setInterval(function() {
                            if (element[0].offsetParent !== null) {
                                new Map(element, {mapPoints: element.data('map-points')}).create();
                                clearInterval(interval);
                            }
                        }, timeout);
                    }
                },

                /**
                 * RatingFilter Change Handler
                 *
                 * @private
                 */
                _onRatingFilterChange: function() {
                    const nextTabName = this.ratingFilter.getValue();
                    this.ttContainer
                        .find('[data-tab-name]')
                        .addClass('is-hidden');
                    this.ttContainer
                        .find('[data-tab-name="' + nextTabName + '"]')
                        .removeClass('is-hidden');
                },

                /**
                 * Binding events to elements
                 * @private
                 */
                _bindEventHandlers: function()
                {
                    var self = this;
                    var hotelDescriptionElement = $('[data-fcse-role="hotel-description"]', this.element);

                    $('[data-fcse-role="hotel-description-collapse"]', this.element).off('click').on('click', function(event) {
                        event.preventDefault();

                        var isCollapsed = hotelDescriptionElement.hasClass('is-collapsed');
                        var iconElement = $('[data-fcse-role="hotel-description-collapse-trigger-icon"]', event.currentTarget);

                        iconElement
                          .removeClass(isCollapsed ? 'icon-chevron-down' : 'icon-chevron-up')
                          .addClass(isCollapsed ? 'icon-chevron-up' : 'icon-chevron-down');

                        hotelDescriptionElement.toggleClass('is-collapsed');

                        if (!isCollapsed) {
                            $(window).scrollTop($('#hotel-description').offset().top);
                        }
                    });

                    this._requestHandler.on('success', function(data, requestData) {
                        if (requestData && requestData.route == self.option('traveltainment_route')) {
                            var contentElement = $(self.option('accordionRatingContentSelector'), self.element);
                            contentElement.removeClass(self.option('loadingClass'));
                            if (data.state == 'OK') {
                                self._hasReviews = true;
                                var content = contentElement.data('iframe-str');
                                $('#ttHib').replaceWith($(content));
                            } else {
                                self._hasReviews = false;
                                $('#ttHib').hide();
                                $(self.option('reviewsFallbackSelector')).show();
                            }
                        }
                    });

                    /*$('[data-fcse-role="raiting-link"]', this.element).on('click', function(event) {
                        event.preventDefault();
                        var ratingAccordion = $('[data-fcse-role="hotel-reviews"]', self.element);

                        if (ratingAccordion.hasClass('is-collapsed')) {
                            ratingAccordion.children('[data-fcse-role="visibility-control"]').click();
                        }
                        $(window).scrollTop(ratingAccordion.offset().top - 250);
                    });*/
                    /*
                    this._requestHandler.on('success', function(data, requestData) {
                         if (requestData && requestData.route == self.option('traveltainment_route')) {
                             $(self.option('accordionRatingContentSelector'), self.element).removeClass(self.option('loadingClass'));
                             if (data.state == 'OK') {
                                 self._hasReviews = true;
                                 var content = $(self.option('accordionRatingContentSelector'), self.element).data('iframe-str');
                                 $('#ttHib').replaceWith($(content));
                             } else {
                                 self._hasReviews = false;
                                 $('#ttHib').hide();
                                 $(self.option('reviewsFallbackSelector')).show();
                             }
                         }
                    });
                    */

                    var changeTab = function(type) {
                        var targetElement = $('#' + type);

                        LazyImage.loadImages(targetElement);

                        if (type === 'hotel-map' &&
                          !self._initMapDone &&
                          targetElement.has(self.mapElement)) {
                            self._initMap('mapElement');
                            return;
                        }

                        if (type === 'hotel-region' &&
                          !self._initDestinationInfoMapDone &&
                          targetElement.has(self.destinationinfoMapElement)) {
                            self._initMap('destinationInfoMap');
                            return;
                        }

                        if (type === 'hotel-rating') {
                            var contentElement = $(self.option('accordionRatingContentSelector'), self.element);
                            if (self._hasReviews === null) {
                                contentElement.addClass(self.option('loadingClass'));
                                self._requestHandler.send(self.option('traveltainment_route'), {
                                    url: encodeURIComponent(contentElement.data('reviews-url'))
                                }, {});
                            } else if (self._hasReviews && window.navigator.userAgent.indexOf('MSIE') != -1) {
                                $('#ttHib').replaceWith($(contentElement.data('iframe-str')));
                            }
                        }
                    };

                    if (this.tabs) {
                        this.tabs.on('change', function(tabType) {
                            changeTab(tabType[0]);
                        });
                    }
                    if (this.mobileSwitcher) {
                        var tabsContainer = $('[data-fcse-role="tabs-container"]');
                        var tabContents = $('[data-fcse-role="tab-content"]', tabsContainer);
                        this.mobileSwitcher.on('change', function() {
                            var type = self.mobileSwitcher.getValue();
                            tabContents.addClass('is-hidden');
                            $('#' + type).removeClass('is-hidden');
                            changeTab(type);
                        });
                    }
                    /*
                    // Class for visibility control
                    var visibilityControl = new VisibilityControl($('[data-fcse-role="visibility-control"]', this.element),{
                        'targetIsVisibleClass': 'is-active',
                        'targetIsHiddenClass': 'is-collapsed'
                    });
                    var visibilityControlDestinationInfo = new VisibilityControl($('[data-fcse-role="visibility-control-destination-info"]', this.element),{
                        'targetIsVisibleClass': 'is-active',
                        'targetIsHiddenClass': 'is-collapsed'
                    });
                    // initializing only when google map block is visible due to render issues when hidden.
                    visibilityControl.on('open', function(targetElement) {
                        if (targetElement.is(self.option('accordionReviewsSelector'))) {
                             if (self._hasReviews === null) {
                                 $(self.option('accordionRatingContentSelector'), targetElement).addClass(self.option('loadingClass'));
                                 self._requestHandler.send(self.option('traveltainment_route'), {
                                     url: encodeURIComponent(targetElement.data('reviews-url'))
                                 }, {});
                             } else if (self._hasReviews && window.navigator.userAgent.indexOf('MSIE') != -1) {
                                 $('#ttHib').replaceWith($($(self.option('accordionRatingContentSelector'), targetElement).data('iframe-str')));
                             }
                        }

                        LazyImage.loadImages(targetElement);
                        if (!self._initMapDone && targetElement.has(self.mapElement)) {
                            self._initMap('mapElement');
                        }

                    });
                    // Destination Info section
                    visibilityControlDestinationInfo.on('open', function(targetElement) {
                        if (!self._initDestinationInfoMapDone && targetElement.has(self.destinationinfoMapElement)) {
                            self._initMap('destinationInfoMap');
                        }
                    });
                    */

                }

            });

        return HotelDetails;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/hoteldetails/hoteldetails.js